import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { UploadService } from 'src/app/shared/upload.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AgendaMasivaModel } from 'src/app/models/agendaMasiva.model';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlControl } from 'src/app/shared/models/generic.model';

@Component({
  selector: 'app-registrar-visita-masiva',
  templateUrl: './registrar-visita-masiva.component.html',
  styleUrls: ['./registrar-visita-masiva.component.scss']
})
export class RegistrarVisitaMasivaComponent implements OnInit {

  @ViewChild('inputFile') inputFile: ElementRef;
  @ViewChild('labelImport')
  labelImport: ElementRef;
  accept = '.xlsx, .xls';
  nombreArchivo: string;
  fileToUpload: File;
  maxSize = 102400;
  listaRegistros: AgendaMasivaModel[] = [];
  cargandoArchivo: boolean;
  sinAdjunto: string;

  error: boolean;

  constructor(private uploadService: UploadService, private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private urlService: UrlService,
    private utilService: UtilService,
    private global: GlobalService,
    private router: Router) {
    this.sinAdjunto = ConstantesService.SIN_ADJUNTO;
    this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
    this.cargandoArchivo = false;
  }

  ngOnInit(): void {
  }

  /**
   * Metodo encargado de detectar el evento del componente de carga de documentos
   */
  onFileChange(event: any) {
    this.listaRegistros = [];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileToUpload = file;
      this.validarArchivo(this.fileToUpload);
      event.target.value = '';
    }
  }

  onClick(event: any) {
    event.target.value = '';
  }

  /**
   * Realiza las validaciones de tamaño y extencion del documento cargado
   */
  validarArchivo(archivo: File) {

    if (archivo) {
      if (!archivo.name.includes('.xls') && !archivo.name.includes('.xlsx')) {
        this.inputFile.nativeElement.value = '';
        return this.alertService.generateAlertError('No se puede cargar el archivo porque no tiene extensión: .xls ó xlsx'
          , 'Error');
      }
      if (archivo.size === 0) {
        this.inputFile.nativeElement.value = '';
        return this.alertService.generateAlertError('No se puede cargar el archivo porque se encuentra vacío', 'Error');
      }
      this.uploadFiles();
    }
  }

  /**
   * Metodo encargado de realizar la carga del documento en el gestor documental
   */
  uploadFiles() {
    this.cargandoArchivo = true;
    this.nombreArchivo = this.fileToUpload.name;
    const formData = new FormData();
    formData.append('file', this.fileToUpload);
    return this.uploadService.cargarArchivo(`/servicios/gestorDocumental?name=${this.nombreArchivo}`, formData)
      .subscribe(data => {
        if (data) {
          this.alertService.generateAlertSuccess('Carga completa', ' ');
          const errores = data.find(dato => dato.registro.errores.length > 0);
          const cruceAgenda = data.find(dato => dato.cruce);
          if (errores && (!cruceAgenda || data[0].registro.errores.length > 1)) {
            this.error = true;
            this.alertService.generateAlertError('No se puede cargar lista, existen errores en el archivo', 'Error');
          }
          if (cruceAgenda) {
            this.error = true;
            this.alertService.generateAlertError('Error no se puede cargar el archivo porque tiene registros de visitantes ' +
              'con agendas ya programadas para la misma fecha y hora ', ' ');
          }
          setTimeout(() => {
            this.listaRegistros = [];
            data.forEach(dato => {
              this.listaRegistros.push(dato.registro);
            });
            this.cargandoArchivo = false;
            this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
          }, 2000);
        }
      }, error => {
        this.cargandoArchivo = false;
        this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
        this.alertService.generateAlertError(error.error.message, ' ');
      });
  }

  /**
   * metodo para regresar a consulat de visitas
   * @author fromero
   */
  regresarListaAgendas() {
    this.router.navigate(['main/']);
  }

  descargarPlantilla() {
    this.spinner.show();
    const serviceProvider = 'descargarPlatillaMasiva';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_UAC);
    this.global.getGenerico(url).subscribe(
      data => {
        this.spinner.hide();
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', data.nombre, data.archivo);
      }, err => {
        if (err.status === '500') {
          this.catchException(err.error.message);
        } else {
          this.catchException('No se ha podido descargar el documento');
        }
      }
    );
  }
  /**
    * Método de control de Excepciones
    * @function cathException
    * @author dfranco@asesoftware.com
    * @param  error  mensaje saliente respecto al error ocurrido
    */
  catchException(error) {
    this.utilService.cathException(error, this.alertService, this.spinner);
  }

}
